function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFredHutch = function SvgFredHutch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.93 36.93"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#feaa00",
    d: "M28.5 2.5c1.333.667 1.333.667 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#005554",
    d: "M35.5 2.5c1.333.667 1.333.667 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.592
    },
    fill: "#0caecb",
    d: "M22.5 7.5c-.667 0-1 .333-1 1-2.576-.222-3.41-1.555-2.5-4 2.658-1.194 3.824-.194 3.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.854
    },
    fill: "#233565",
    d: "M34.5 3.5h1c.333 1 1 1.667 2 2v1c-.838.342-1.172 1.008-1 2a5.728 5.728 0 0 1-3 1l1-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#005554",
    d: "M37.5 4.5c1.333.667 1.333.667 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9b216",
    d: "m28.5 3.5 2 3c-.667 0-1 .333-1 1-.667 0-1 .333-1 1-.667 0-1 .333-1 1-.667 0-1 .333-1 1h-1l-1-4c.762-1.762 2.096-2.762 4-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "navy",
    d: "M37.5 6.5c1.333.667 1.333 1.333 0 2v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#1e375e",
    d: "m34.5 3.5-1 6v1c-.667 0-1 .333-1 1-.667 0-1 .333-1 1h-1c-1.333-1.667-1.333-3.333 0-5v-1l4-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#fdb60a",
    d: "m24.5 6.5 1 4v1c-.667 0-1 .333-1 1h-1c-1.1-1.105-1.767-2.438-2-4 .667 0 1-.333 1-1l2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#00403f",
    d: "M36.5 8.5h1c-.185.67-.519.67-1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#203160",
    d: "M29.5 7.5h1c-1.333 1.667-1.333 3.333 0 5v1c-.667 0-1 .333-1 1-.667 0-1 .333-1 1-.6-1.4-1.6-2.4-3-3v-1c.667 0 1-.333 1-1 .667 0 1-.333 1-1 .667 0 1-.333 1-1 .667 0 1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    d: "M37.5 11.5c-.667-1.333-.667-1.333 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.709
    },
    fill: "#feb809",
    d: "M8.5 14.5c-.667 0-1 .333-1 1h-3c-.384-2.165.283-3.832 2-5 1.611.82 2.278 2.154 2 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#a955aa",
    d: "M37.5 11.5c1.333.667 1.333.667 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#ff9dfa",
    d: "M2.5 11.5c1.098 1.1 1.265 2.434.5 4-1.334-1.378-1.5-2.711-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b14cc6",
    d: "M33.5 10.5a5.728 5.728 0 0 1 3 1v4c-1 .333-1.667 1-2 2-.667 0-1 .333-1 1h-1c.27-1.88-.396-3.213-2-4v-1c.667 0 1-.333 1-1 .667 0 1-.333 1-1 .667 0 1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad4cc7",
    d: "M13.5 15.5c-1.208-.734-2.541-1.067-4-1 .979-1.645 2.312-2.979 4-4 2.563 1.835 2.563 3.502 0 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#d74cdf",
    d: "M16.5 11.5c1.098 1.1 1.265 2.434.5 4a8.434 8.434 0 0 1-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#4e494e",
    d: "M23.5 12.5v1c-.667 0-1 .333-1 1-1.257-1.123-.924-1.79 1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#1e3357",
    d: "M24.5 12.5h1c1.4.6 2.4 1.6 3 3v1h-1c-1.562-.233-2.895-.9-4-2v-1c.667 0 1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b149cb",
    d: "M8.5 14.5h1c1.459-.067 2.792.266 4 1a303.438 303.438 0 0 1-3 4 6.541 6.541 0 0 0-3-3v-1c.667 0 1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#d35ad2",
    d: "M37.5 15.5a2.428 2.428 0 0 1 .5-2c.692.937.525 1.603-.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.723
    },
    fill: "#1e365e",
    d: "M22.5 14.5h1c1.105 1.1 2.438 1.767 4 2v1c-.667 0-1 .333-1 1-.667 0-1 .333-1 1h-4c-.134-1.791.2-3.458 1-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad4cc8",
    d: "M29.5 14.5h1c1.604.787 2.27 2.12 2 4-1.462.97-2.795.638-4-1v-2c.667 0 1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#be40bf",
    d: "M36.5 15.5h1c-.185.67-.519.67-1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.649
    },
    fill: "#aa4cc5",
    d: "M7.5 16.5a6.541 6.541 0 0 1 3 3l-2 2c-.667 0-1 .333-1 1h-3c-.475-2.813.525-4.813 3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#542b80",
    d: "M27.5 17.5h1c-.185.67-.519.67-1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#00fffe",
    d: "M37.5 18.5c-.667-1.333-.667-1.333 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#003266",
    d: "M26.5 18.5h1c-.185.67-.519.67-1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.702
    },
    fill: "#22a3c1",
    d: "m34.5 17.5 2 1v4h-4v-4h1c.667 0 1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#00aaa9",
    d: "M37.5 18.5c1.333.667 1.333.667 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6441ff",
    d: "M2.5 18.5c1.098 1.1 1.265 2.434.5 4-1.334-1.378-1.5-2.711-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#32829f",
    d: "M21.5 19.5c1.068.934 2.401 1.268 4 1a26.326 26.326 0 0 1-5 2c0-1.333-.667-2-2-2 .605-1.981 1.605-2.315 3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#00403f",
    d: "M25.5 19.5h1c-.185.67-.519.67-1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#fe00ff",
    d: "M28.5 19.5c1.333.667 1.333.667 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.642
    },
    fill: "#00adcc",
    d: "M18.5 20.5c.333 1 1 1.667 2 2-.526 1.73-1.526 3.064-3 4-2 0-3-1-3-3 .762-1.762 2.096-2.762 4-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#282f3f",
    d: "M30.5 20.5c1.025.397 1.192 1.063.5 2a2.428 2.428 0 0 1-.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#2ea9ff",
    d: "M37.5 22.5a2.428 2.428 0 0 1 .5-2c.692.937.525 1.603-.5 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#00807f",
    d: "M36.5 22.5h1c-.185.67-.519.67-1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#188c95",
    d: "M36.5 23.5c-.889 2.359-2.222 2.525-4 .5a8.434 8.434 0 0 1 4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#1b375b",
    d: "M8.5 21.5h1a19.24 19.24 0 0 1-1 6v1h-1c-1.062-1.6-1.062-3.266 0-5v-1c.667 0 1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#1b3a61",
    d: "M9.5 21.5c2 0 3 1 3 3-.667 0-1 .333-1 1-.667 0-1 .333-1 1-.667 0-1 .333-1 1h-1a19.24 19.24 0 0 0 1-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.634
    },
    fill: "#1d375f",
    d: "M7.5 23.5c-1.062 1.734-1.062 3.4 0 5v1h-3c-.475-2.813.525-4.813 3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#24aecc",
    d: "M14.5 23.5c0 2 1 3 3 3l-1 2h-1c-.667 0-1 .333-1 1h-1c-.473-1.406-1.473-2.073-3-2v-1c.667 0 1-.333 1-1 .667 0 1-.333 1-1l2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.624
    },
    fill: "#1b365e",
    d: "M29.5 28.5c-1.653-.16-2.986-.826-4-2 1.068-.934 2.401-1.268 4-1v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#15142e",
    d: "M2.5 25.5c1.098 1.1 1.265 2.434.5 4-1.768-1.182-1.935-2.515-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0fafcc",
    d: "M9.5 27.5h1c1.527-.073 2.527.594 3 2v1c-.667 0-1 .333-1 1h-1l-2-3v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.673
    },
    fill: "#1f3658",
    d: "M25.5 26.5c1.014 1.174 2.347 1.84 4 2v1c-1 .333-1.667 1-2 2-.667 0-1 .333-1 1-.667 0-1 .333-1 1h-1c.219-1.175-.114-2.175-1-3-.765 1.112-1.765 1.779-3 2v-1c1.333-2 3-3.667 5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#131396",
    d: "M30.5 29.5a8.434 8.434 0 0 1 .5-4c.765 1.566.598 2.9-.5 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#0cafd4",
    d: "M8.5 28.5h1l2 3v2h-1c-.333-1-1-1.667-2-2 0-.667-.333-1-1-1v-1c.667 0 1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#003f80",
    d: "M29.5 29.5h1c-.185.67-.519.67-1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#fcb519",
    d: "M15.5 28.5h2l-5 6h-1v-2c.667 0 1-.333 1-1 .667 0 1-.333 1-1 .667 0 1-.333 1-1 .667 0 1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#febc01",
    d: "M17.5 28.5c1.406.473 2.073 1.473 2 3-.667 0-1 .333-1 1v1h-1c-1.544.203-2.878.87-4 2-.607-.124-.94-.457-1-1l5-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.949
    },
    fill: "#04b1cf",
    d: "M8.5 31.5c1 .333 1.667 1 2 2-1.544.203-2.878.87-4 2-.895-1.845-.228-3.178 2-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#203461",
    d: "M19.5 31.5h1v1c-.073 1.527.594 2.527 2 3v1h-4v-4c.667 0 1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.933
    },
    fill: "#1c375e",
    d: "M24.5 33.5c-.333 1-1 1.667-2 2-1.406-.473-2.073-1.473-2-3 1.235-.221 2.235-.888 3-2 .886.825 1.219 1.825 1 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#2b8ba2",
    d: "M2.5 32.5c1.098 1.1 1.265 2.434.5 4-1.768-1.182-1.935-2.515-.5-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.551
    },
    fill: "#0fabc7",
    d: "M7.5 30.5c.667 0 1 .333 1 1-2.228.822-2.895 2.155-2 4 1.122-1.13 2.456-1.797 4-2l-2 3h-4c-.475-2.813.525-4.813 3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#8b64d7",
    d: "M30.5 36.5a8.434 8.434 0 0 1 .5-4c.765 1.566.598 2.9-.5 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.627
    },
    fill: "#fdb504",
    d: "m17.5 33.5-2 3c-1.983.343-3.317-.324-4-2h1c.06.543.393.876 1 1 1.122-1.13 2.456-1.797 4-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.114
    },
    fill: "#a548c0",
    d: "M27.5 31.5c1.713 1.135 2.38 2.802 2 5h-4v-3c0-.667.333-1 1-1s1-.333 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#007fbf",
    d: "M8.5 36.5c1.333.667 1.333.667 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#febf00",
    d: "M15.5 36.5c1.333.667 1.333.667 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#00403f",
    d: "M22.5 36.5c1.333.667 1.333.667 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#7f0080",
    d: "M29.5 36.5h1c-.185.67-.519.67-1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#00c7c7",
    d: "M8.5 37.5c-1.1 1.098-2.434 1.265-4 .5a8.434 8.434 0 0 1 4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#ffc700",
    d: "M15.5 37.5c-1.1 1.098-2.434 1.265-4 .5a8.434 8.434 0 0 1 4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#113a77",
    d: "M22.5 37.5c-1.1 1.098-2.434 1.265-4 .5a8.434 8.434 0 0 1 4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#ae4ab9",
    d: "M29.5 37.5c-1.1 1.098-2.434 1.265-4 .5a8.434 8.434 0 0 1 4-.5Z"
  }));
};
export default SvgFredHutch;